import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TemplateManager } from '../../components/crm/contracts/TemplateManager';
import { FeatureGate } from '../../components/common/FeatureGate';

export const ContractTemplatesPage: React.FC = () => {
  const navigate = useNavigate();

  const handleUseTemplate = (contractId: number) => {
    navigate(`/crm/contracts/${contractId}`);
  };

  const handleBackToContracts = () => {
    navigate('/crm/contracts');
  };

  return (
    <FeatureGate
      requiredTiers={['pro', 'premium', 'enterprise']}
      featureName="Contract Templates"
      featureDescription="Create and manage reusable contract templates to streamline your sales process and close deals faster."
      benefits={[
        'Save time with pre-built contract templates',
        'Ensure consistency across all contracts',
        'Customize templates with dynamic fields',
        'Track template usage and performance',
        'Upload and manage PDF templates',
        'Auto-populate customer information'
      ]}
    >
      <TemplateManager
        onUseTemplate={handleUseTemplate}
        onClose={handleBackToContracts}
      />
    </FeatureGate>
  );
};
